<template>

  <breadcrumb :links="{'/': 'Home', 'current': 'Radar'}"></breadcrumb>

	<div>
    <div class="section section_odd">
      <div class="container-xl">
        <h1>Radar</h1>
        <div v-if="! radarAvailable"  class="alert alert-warning" role="alert"><i class="bi bi-exclamation-triangle"></i> {{ radarNotAvailable() }}</div>
        <div class="row">
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="radar/VMI">
              <figure class="figure">
                <img src="../assets/home_vmi.png" class="figure-img img-fluid border" alt="Riflettività">
                <figcaption class="figure-caption fs-4"><i class="bi bi-rainbow"></i> Riflettività</figcaption>
              </figure>
            </router-link>
          </div>
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="radar/SRI">
              <figure class="figure">
                <img src="../assets/home_sri.png" class="figure-img img-fluid border" alt="Precipitazioni">
                <figcaption class="figure-caption fs-4"><i class="bi bi-cloud-rain"></i> Precipitazioni</figcaption>
              </figure>
            </router-link>
          </div>
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="vento">
              <figure class="figure">
                <img src="../assets/home_w.png" class="figure-img img-fluid border" alt="Vento">
                <figcaption class="figure-caption fs-4"><i class="bi bi-wind"></i> Vento</figcaption>
              </figure>
            </router-link>
          </div>
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="temporali">
              <figure class="figure">
                <img src="../assets/home_storm.png" class="figure-img img-fluid border" alt="Temporali">
                <figcaption class="figure-caption fs-4"><i class="bi bi-cloud-lightning-rain"></i> Temporali</figcaption>
              </figure>
            </router-link>
          </div>
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="radar_hmc">
              <figure class="figure">
                <img src="../assets/home_hmc.png" class="figure-img img-fluid border" alt="Classificazione precipitazioni">
                <figcaption class="figure-caption fs-4"><i class="bi bi-cloud-lightning-rain"></i> Classificazione</figcaption>
              </figure>
            </router-link>
          </div>
        </div>
      </div>
    </div>
	</div>

  <app-footer></app-footer>

</template>

<script>
  import AppFooter from '@/app-footer.vue'
  import Breadcrumb from '@/components/Breadcrumb'
  import MonitorApi from '@/services/MonitorApi';
  import Labels from '@/utils/labels';

  export default {
    components: {AppFooter, Breadcrumb},
    mixins: [Labels],
    data: function() {
      return {
        radarAvailable: true
      }
    },
    methods: {
      checkRadarAvailability: async function(radar_name){
        const max_time = 129600000; // 36 h
        let to = new Date;
        if(this.radar_time) {
          to = this.radar_time;
        }
        const from = new Date(to - max_time);
        let products;
        products = await MonitorApi.getRadarProducts(1, radar_name, from, to, 1);
        this.radarAvailable = products.length > 0;
      }
    },
    mounted: function(){
      this.checkRadarAvailability('VMI');
    }
  }
</script>

<style scoped lang="scss">
  .container-layout{
    text-align: center;
  }
  .figure-caption {
    width: 100%;
    //margin-left: 5px;
    //margin-top: -20px;
    background-color: #f1f6f1;
    //z-index: 1010;
    display: block;
    //position: relative;
    //padding-left: 5px;
    font-variant: small-caps;
    font-weight: bold;
    color: #0067b1;
  }
  .section_odd {
    .figure-caption {
      background-color: #fff;
    }
  }

</style>